 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~._m": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"AccountInfo~._src_views_PersonalCenter_AccountInfo_AccountInfo.vue~3":"AccountInfo~._src_views_PersonalCenter_AccountInfo_AccountInfo.vue~3","ActivityData~._src_a":"ActivityData~._src_a","ActivityDetail~._src_views_ActivityDetail_ActivityDetail.vue~0":"ActivityDetail~._src_views_ActivityDetail_ActivityDetail.vue~0","CollectedTemp~._src_a":"CollectedTemp~._src_a","CompanyInfo~MarketingActivityEdit~OnlinePrinting~PostersEdit~PrizeResources~._n":"CompanyInfo~MarketingActivityEdit~OnlinePrinting~PostersEdit~PrizeResources~._n","CompanyInfo~MarketingActivityEdit~PostersEdit~ReceivingAddress~._node_modules_element-china-area-dat~1ab1a4d6":"CompanyInfo~MarketingActivityEdit~PostersEdit~ReceivingAddress~._node_modules_element-china-area-dat~1ab1a4d6","CompanyInfo~._src_a":"CompanyInfo~._src_a","MarketingActivityEdit~PrizeResources~._src_a":"MarketingActivityEdit~PrizeResources~._src_a","MarketingActivityEdit~._n":"MarketingActivityEdit~._n","PostersEdit~._n":"PostersEdit~._n","PrizeResources~._src_views_OwnWorkbench_PrizeResources_PrizeResources.vue~1":"PrizeResources~._src_views_OwnWorkbench_PrizeResources_PrizeResources.vue~1","OnlinePrinting~._n":"OnlinePrinting~._n","ReceivingAddress~._src_views_PersonalCenter_ReceivingAddress_ReceivingAddress.vue~1":"ReceivingAddress~._src_views_PersonalCenter_ReceivingAddress_ReceivingAddress.vue~1","DemandOrderList~._n":"DemandOrderList~._n","Index~._src_a":"Index~._src_a","InfiniteQRCode~._src_a":"InfiniteQRCode~._src_a","InvioceInfo~._src_views_PersonalCenter_InvioceInfo_InvioceInfo.vue~0":"InvioceInfo~._src_views_PersonalCenter_InvioceInfo_InvioceInfo.vue~0","MarketingActivities~._n":"MarketingActivities~._n","OperationWorkbench~._src_a":"OperationWorkbench~._src_a","OrderForMe~._n":"OrderForMe~._n","OwnActivity~QRManagement~._src_a":"OwnActivity~QRManagement~._src_a","OwnActivity~._src_views_OwnWorkbench_OwnActivity_OwnActivity.vue~6":"OwnActivity~._src_views_OwnWorkbench_OwnActivity_OwnActivity.vue~6","QRManagement~._n":"QRManagement~._n","OwnAddress~._src_a":"OwnAddress~._src_a","OwnWorkbench~._src_a":"OwnWorkbench~._src_a","Payment~._src_views_Order_Payment.vue~1":"Payment~._src_views_Order_Payment.vue~1","PrintOrder~._n":"PrintOrder~._n","PrintingJoin~._src_a":"PrintingJoin~._src_a","PrivacyAgreement~._src_views_Agreement_PrivacyAgreement.vue~1":"PrivacyAgreement~._src_views_Agreement_PrivacyAgreement.vue~1","PrizeOrder~._src_a":"PrizeOrder~._src_a","ShoppingCart~._n":"ShoppingCart~._n","TemplateOrder~._src_a":"TemplateOrder~._src_a","UserAgreement~._src_views_Agreement_UserAgreement.vue~2":"UserAgreement~._src_views_Agreement_UserAgreement.vue~2","login~._src_views_login_login.vue~2":"login~._src_views_login_login.vue~2","qqCallback~._src_views_callback_qqCallback.vue~2":"qqCallback~._src_views_callback_qqCallback.vue~2"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~._node_modules_@","chunk-vendors~._node_modules_b","chunk-vendors~._node_modules_d","chunk-vendors~._node_modules_echarts_l","chunk-vendors~._node_modules_echarts_lib_c","chunk-vendors~._node_modules_echarts_lib_component_a","chunk-vendors~._node_modules_echarts_lib_i","chunk-vendors~._node_modules_element-ui_l","chunk-vendors~._node_modules_element-ui_lib_a","chunk-vendors~._node_modules_element-ui_lib_b","chunk-vendors~._node_modules_element-ui_lib_h","chunk-vendors~._node_modules_element-ui_lib_m","chunk-vendors~._node_modules_element-ui_src_l","chunk-vendors~._node_modules_j","chunk-vendors~._node_modules_r","chunk-vendors~._node_modules_v"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
